import { render, staticRenderFns } from "./resourceList.vue?vue&type=template&id=34ca0b56&scoped=true&"
import script from "./resourceList.vue?vue&type=script&lang=ts&"
export * from "./resourceList.vue?vue&type=script&lang=ts&"
import style0 from "./resourceList.vue?vue&type=style&index=0&id=34ca0b56&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ca0b56",
  null
  
)

export default component.exports